import React from 'react'

export default function Icon(props) {
  return (
    <svg viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M3 6.98438H21V8.98438H3V6.98438Z" fill="var(--svg-color-main, black)" />
      <path d="M3 11.9844H21V13.9844H3V11.9844Z" fill="var(--svg-color-main, black)" />
      <path d="M3 16.9844H21V18.9844H3V16.9844Z" fill="var(--svg-color-main, black)" />
    </svg>
  )
}
